import { Component } from '@angular/core'

import { QuestionTypeView, QuestionViewService } from '../'

@Component({
  selector: 'mp-flash-card-question-view',
  templateUrl: './flash-card-question-view.html'
})

export class FlashCardQuestionViewComponent extends QuestionTypeView {

  public constructor(
     _questionViewService: QuestionViewService
  ) { super(_questionViewService) }

}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/angular/components/question-view/flash-card-question-view/flash-card-question-view.component.ts